module.exports = __webpack_public_path__ + "img/courseimg4.e34cb065.png";